__turbopack_context__.v({
  "backgroundImage": "PlpHero-module-scss-module__Nn6N2W__backgroundImage",
  "backgroundVideo": "PlpHero-module-scss-module__Nn6N2W__backgroundVideo",
  "capitalized": "PlpHero-module-scss-module__Nn6N2W__capitalized",
  "coloredText": "PlpHero-module-scss-module__Nn6N2W__coloredText",
  "content": "PlpHero-module-scss-module__Nn6N2W__content",
  "expandButton": "PlpHero-module-scss-module__Nn6N2W__expandButton",
  "heading": "PlpHero-module-scss-module__Nn6N2W__heading",
  "hero": "PlpHero-module-scss-module__Nn6N2W__hero",
  "heroBackground": "PlpHero-module-scss-module__Nn6N2W__heroBackground",
  "mediaContainer": "PlpHero-module-scss-module__Nn6N2W__mediaContainer",
  "overlay": "PlpHero-module-scss-module__Nn6N2W__overlay",
  "simpleContent": "PlpHero-module-scss-module__Nn6N2W__simpleContent",
  "subheader": "PlpHero-module-scss-module__Nn6N2W__subheader",
  "textBelowContainer": "PlpHero-module-scss-module__Nn6N2W__textBelowContainer",
});
